import { db } from '../../utils/firebase';
// import { collection, getDocs } from "firebase/firestore";

export const getAllUSCTeachings = async () => {
    const USC_classes = [];
    const USC = await  db
        .collection("teaching")
        .doc("University of Southern California")
        .collection("classes")
        .get();
    USC.forEach((doc) => {
        // doc.data() is never undefined for query doc snapshots
        USC_classes.push(doc.data());
    });
    USC_classes.sort(function(a, b){
        if (a.title == "<p><b><a href=\"http://robotics.usc.edu/~maja/teaching/engr150.html\">ENGR 150 Engineering Science and Systems: From Humans to Robots</a></b>             </p>             <p>                 Maja Matari&#263;</p>"){
            return -1;
        } else if (b.title == "<p><b><a href=\"http://robotics.usc.edu/~maja/teaching/engr150.html\">ENGR 150 Engineering Science and Systems: From Humans to Robots</a></b>             </p>             <p>                 Maja Matari&#263;</p>"){
            return 1;
        }
        let x = a.title.toLowerCase();
        let y = b.title.toLowerCase();
        if (x < y) {return 1;}
        if (x > y) {return -1;}
        return 0;
    });
    return USC_classes;
}

export const getAllBrandeisTeachings = async () => {
    const USC_classes = [];
    const USC = await  db
        .collection("teaching")
        .doc("Brandeis University")
        .collection("classes")
        .get();
    USC.forEach((doc) => {
        // doc.data() is never undefined for query doc snapshots
        USC_classes.push(doc.data());
    });
    return USC_classes;
}
